import { isNil } from 'lodash';
import { getLogos, postNewLogo } from '../common/callAPIs';
import { useEffect, useState } from 'react';
import { replaceS3WithCF } from '../common/replaceS3WithCF';
import { updateLogoSelect } from '../js/webGL';
import { setLoading } from '../redux-tool/slice/uiSlice';
import { useDispatch } from 'react-redux';

// Get resolution from a File without touching the DOM
function getImageResolution(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const result = { width: img.naturalWidth, height: img.naturalHeight };
      console.log('----------RESULT---------------', result);
      URL.revokeObjectURL(url);
      resolve(result);
    };
    img.onerror = (e) => {
      URL.revokeObjectURL(url);
      reject(e);
    };
    img.src = url;
  });
}

export function useLoadLogos(queryInfo, productInfo, product) {
  const [logoList, setLogoList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isNil(product)) return;
    loadLogos();
  }, [product]);

  const loadLogos = async () => {
    getLogos(queryInfo, productInfo)
      .then((res) => {
        if (res.status !== 200) throw new Error('Fail to load logos');

        return res.json();
      })
      .then((data) => {
        if (!data) throw new Error('Some thing went wrong');

        const logos = data?.map((item) => {
          const temp = product?.design_hub_object?.logos?.find((i) => i?.Id === item?.element_id);
          return {
            Id: item?.element_id,
            Thumbnail: replaceS3WithCF(item?.thumbnail),
            Scale: item?.scale,
            Rotate: item?.rotate,
            ThumbnailImg: replaceS3WithCF(item?.thumbnail_img || item?.thumbnail),
            IsPattern: item?.type_element == 1,
            ...temp,
          };
        });

        setLogoList(logos);
      })
      .catch((error) => {
        console.log('ERROR WHEN LOADING PRODUCT', error);
      });
  };

  const processAddNewLogo = async (e) => {
    try {
      if (e.target?.files?.length > 0) {
        const file = e.target.files[0];
        await getImageResolution(file);
        const reader = new FileReader();
        reader.onloadend = async () => {
          const base64String = reader.result;
          if (base64String) {
            const [typePart, valuePart] = base64String.split(',');
            const type = typePart.match(/:(.+);/)[1];

            const body = {
              design_data: {
                type: 'logo',
                extension: type.split('/')[1],
                content_file: valuePart || '',
              },
            };

            const res = await postNewLogo(queryInfo, productInfo, body);
            const result = await res.json();

            const logo = {
              Id: result?.element_data?.element_id,
              Thumbnail: result?.element_data?.thumbnail,
              Scale: result?.element_data?.scale,
              Rotate: result?.element_data?.rotate,
              file: result?.element_data?.thumbnail,
              IsPattern: false,
            };

            setLogoList((prev) => [logo, ...prev]);
            updateLogoSelect(logo);
          }
          dispatch(setLoading(false));
        };

        reader.readAsDataURL(file);
      } else {
        dispatch(setLoading(false));
      }
    } catch (error) {
      console.error('Error uploading logo:', error);
      dispatch(setLoading(false));
    }
  };

  const handleAddNewLogo = (e) => {
    dispatch(setLoading(true)); // Turn on loading

    // Defer processing logic so React can render first
    setTimeout(() => {
      processAddNewLogo(e);
    }, 0);
  };
  return { logoList, handleAddNewLogo };
}
